import i18n from '../locales/index'
import Web3 from "web3";

const hardhatWeb3 = new Web3(new Web3.providers.HttpProvider("http://127.0.0.1:8545/"));

export default hardhatWeb3;